import { render, staticRenderFns } from "./ListStyle.vue?vue&type=template&id=0da736ac&scoped=true"
import script from "./ListStyle.vue?vue&type=script&lang=js"
export * from "./ListStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da736ac",
  null
  
)

export default component.exports